import { render, staticRenderFns } from "./AppPane5.vue?vue&type=template&id=8676515c&scoped=true&"
import script from "./AppPane5.vue?vue&type=script&lang=js&"
export * from "./AppPane5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8676515c",
  null
  
)

export default component.exports